<template>

</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, toRaw, reactive,
  createApp,
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';
import ElementPlus from 'element-plus';
import { svgControlCreate } from '@/utils/js/leafletUtils';

import { queryDictDataListByType, } from '@/api/DictApi';
import TextEdit from '../TextEdit';
import EditPolygon from '../EditPolygon';

// props
const props = defineProps({
  layerList: { type: Array, },
  parentTarget: { type: Object, },
  bizType: { type: Number, },
});
// emit
const emit = defineEmits([
  
]);
const homeMap = computed(()=> store.getters['getHomeMap'] ),
      map = toRaw(homeMap.value),
      layerGroup = L.featureGroup().addTo(map),
      layerGroupClose = ()=>{
        map.removeLayer(layerGroup);
      },
      layerGroupClear = ()=>{
        layerGroup.clearLayers();
      },
      layerGroupAdd = ()=>{
        map.addLayer(layerGroup);
      }
const layerRemoveFn = (layer, group)=>{
  layerGroup.removeLayer(layer);
  if(group && group[polygonListProp]){
    const index = group[polygonListProp].findIndex(poly=>{
      return poly._leaflet_id == layer._leaflet_id;
    })
    group[polygonListProp].splice(index, 1);
  }
}

const customMarkerTypeProp = store.getters['leafletPolygon/customMarkerTypeProp'],
      customTextProp = store.getters['leafletPolygon/customTextProp'],
      customTextColorProp = store.getters['leafletPolygon/customTextColorProp'];

const polygonListProp = 'polygonList';
const dataChangePolygon = (data, group)=>{
  const list = [];
  if(data.length == 0)return list;
  data.forEach(item => {
    const geoStr = JSON.parse(item['geom']),
          properties = geoStr['properties'];
    let layer;
    const geojson = L.geoJSON(geoStr).eachLayer(e=>{
      e['options']['dataItem'] = item;
      layer = e;
    });
    const target = reactive({
      ...item,
      favoriteList: props.layerList,
      ...properties,
      echoList,
      eventSt: props.parentTarget && props.parentTarget['start'],
      eventEt: props.parentTarget && props.parentTarget['end'],
    })
    // console.log(target, layer);
    if(layer['feature']['properties'][customMarkerTypeProp] == customTextProp){
      // 自定义文本dom
      const textApp = createApp(TextEdit, {
        target: target,
        layer: layer,
      });
      const textDiv = document.createElement("div");
      textApp.use(ElementPlus);
      textApp.mount(textDiv);
      layer.setIcon(
        L.divIcon({
          html: textDiv,
          className: 'text-edit-container',
        })
      );
    }

    const app = createApp(EditPolygon, {
      target: target,
      layer: layer,
      group: group,
      layerRemoveFn: layerRemoveFn,
      selectListInitFn: selectListInit,
      bizType: props.bizType,
    });
    const div = document.createElement("div");
    div.className = 'leaflet-popup-edit-polygon-div';
    app.use(ElementPlus);
    app.mount(div);
    layer.bindPopup(div, {
      // offset: [0, 28],
      closeButton: false,
      autoClose: false,
      // closeOnClick: false,
      direction: 'top',
      className: 'leaflet-popup-edit-polygon',
    })
    layer.addTo(layerGroup);
    list.push(layer);
  });
  return list;
}

let drawControl, textControl, fileControl,
    drawControlClose = ()=>{
      if(drawControl){
        map.off(L.Draw.Event.DRAWSTART);
        map.off(L.Draw.Event.CREATED);
        map.removeControl(drawControl);
      }
    },
    textControlClose = ()=>{
      textControl && map.removeControl(textControl);
    },
    fileControlClose = ()=>{
      textControl && map.removeControl(fileControl);
    }

const textLayerClose = ()=>{
  map.getContainer().style.cursor = '';
  map.off('click', textLayerInit);
  map.off('contextmenu', textLayerClose);
}
const textLayerInit = (e)=>{
  // console.log(e);
  const { latlng } = e;
  try{
    const target = reactive({
      favoriteList: props.layerList,
      echoList,
      eventSt: props.parentTarget && props.parentTarget['start'],
      eventEt: props.parentTarget && props.parentTarget['end'],
    })

    const layer = L.marker(latlng, {
    })
    // 自定义文本dom
    const textApp = createApp(TextEdit, {
      target: target,
      layer: layer,
    });
    const textDiv = document.createElement("div");
    textApp.use(ElementPlus);
    textApp.mount(textDiv);
    layer.setIcon(
      L.divIcon({
        html: textDiv,
        className: 'text-edit-container',
      })
    );

    // 图层dom
    const app = createApp(EditPolygon, {
      target: target,
      layer: layer,
      layerRemoveFn: layerRemoveFn,
      selectListInitFn: selectListInit,
      bizType: props.bizType,
    });
    const div = document.createElement("div");
    div.className = 'leaflet-popup-edit-polygon-div';
    app.use(ElementPlus);
    app.mount(div);

    layer.bindPopup(div, {
      // offset: [0, 0],
      closeButton: false,
      autoClose: false,
      // closeOnClick: false,
      direction: 'top',
      className: 'leaflet-popup-edit-polygon',
    })

    layer.addTo(layerGroup);
  }catch (error) {
    console.log(error);
    textLayerClose();
  }
  textLayerClose();
}
// 取消绘制
const drawClearFn = ()=>{
  const clearBtn = document.querySelector('.leaflet-draw-actions li a[title=取消绘图]')
  clearBtn && clearBtn.click();
}

const textCreateFn = (e)=>{
  if(map.getContainer().style.cursor == 'crosshair'){
    textLayerClose();
    return
  }
  drawClearFn();
  map.getContainer().style.cursor = 'crosshair';
  map.on('click', textLayerInit);
  map.on('contextmenu', textLayerClose);
}

const fileExportFn = (e)=>{
  // 文件上传control
  const fileButton = document.createElement('input');
  fileButton.type = 'file';
  fileButton.accept = '.json,.geojson';
  fileButton.click();
  try {
    fileButton.onchange = (e)=>{
      document.activeElement.style['cursor'] = 'wait';
      const fileInput = e.target,
            file = Array.from(fileInput['files']).at(0);
      if(!file)return;
      const reader = new FileReader();
      reader.readAsText(file);
      reader.onload = (e)=>{
        document.activeElement.style['cursor'] = 'default';
        // console.log(e);
        const that = e.target,
        json = JSON.parse(that['result']);
        L.geoJSON(json, {
          onEachFeature: (feature, layer)=>{
            const target = reactive({
              favoriteList: props.layerList,
              echoList,
              eventSt: props.parentTarget && props.parentTarget['start'],
              eventEt: props.parentTarget && props.parentTarget['end'],
            });

            const app = createApp(EditPolygon, {
              target: target,
              layer: layer,
              layerRemoveFn: layerRemoveFn,
              selectListInitFn: selectListInit,
              bizType: props.bizType,
            });
            const div = document.createElement("div");
            div.className = 'leaflet-popup-edit-polygon-div';
            app.use(ElementPlus);
            app.mount(div);
            layer.bindPopup(div, {
              // offset: [0, 0],
              closeButton: false,
              autoClose: false,
              // closeOnClick: false,
              direction: 'top',
              className: 'leaflet-popup-edit-polygon',
            });

            layerGroup.addLayer(layer);
          }
        })
      }
    }
  }catch (error) {
    document.activeElement.style['cursor'] = 'default';
  }
}

const controlInit = ()=>{
  textControl = svgControlCreate({
    title: '文本',
    svgName: 'text-border',
  }, 'click', textCreateFn).addTo(map);

  fileControl = svgControlCreate({
    title: '文件上传',
    svgName: 'file-export',
  }, 'click', fileExportFn).addTo(map);

  // console.log(map);
  drawControl = new L.Control.Draw({
    position: 'topright',
    draw: {
      polyline: true,
      rectangle: true,
      circle: true,
      polygon: true,

      marker: true,
      circlemarker: false
    },
    edit: {
      featureGroup: layerGroup,
      remove: false,
      edit: true,
    }
  }).addTo(map);

  map.on(L.Draw.Event.DRAWSTART, event => {
    textLayerClose();
  })
  map.on(L.Draw.Event.CREATED, event=>{
    const layer = event.layer;
    const target = reactive({
      favoriteList: props.layerList,
      echoList,
      eventSt: props.parentTarget && props.parentTarget['start'],
      eventEt: props.parentTarget && props.parentTarget['end'],
    });

    const app = createApp(EditPolygon, {
      target: target,
      layer: layer,
      layerRemoveFn: layerRemoveFn,
      selectListInitFn: selectListInit,
      bizType: props.bizType,
    });
    const div = document.createElement("div");
    div.className = 'leaflet-popup-edit-polygon-div';
    app.use(ElementPlus);
    app.mount(div);
    layer.bindPopup(div, {
      // offset: [0, 0],
      closeButton: false,
      autoClose: false,
      // closeOnClick: false,
      direction: 'top',
      className: 'leaflet-popup-edit-polygon',
    });

    layerGroup.addLayer(layer);
  })
}

let echoList = [];
const echoListInit = ()=>{
  queryDictDataListByType({
    dictType: 'RELATED_INFORMATION_TYPE',
  }).then(res=>{
    if(res.data.code == 1004){
      echoList = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}
const selectListInit = ()=>{
  // echoListInit();
}

defineExpose({
  dataChangePolygon,
  layerRemoveFn,
  layerGroupAdd,
  layerGroupClose,
})

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{
  nextTick(()=>{
    controlInit();
    selectListInit();
  })
});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{
  drawControlClose();
  textControlClose();
  fileControlClose();
  layerGroupClose();
});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>

</style>